var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"cc-day-of-week"},_vm._l((_vm.weekdays),function(weekday){return _c('li',{key:weekday},[_vm._v(_vm._s(weekday))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }